// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.File-module__fileNameWrapper--ZpBLN {
  cursor: pointer;
  border-radius: 0.25rem;
  width: calc(100% - 3.6rem);
  /* prevents from overflowing the filetree */
}

.File-module__fileNameWrapper--ZpBLN:hover .File-module__innerWrapper--OAaH9 {
  width: calc(100% - 3.6rem);
  /* gives room for Reset/Delete buttons (File.tsx) after filename */
  transition: width 0s 0s;
}

.File-module__innerWrapper--OAaH9 {
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  letter-spacing: 0.01rem;
  width: 100%;
  transition: width 0.1s 0.1s;
}

.File-module__fileName--pUMjq {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
}

.File-module__optionsContainer--Z3EVn {
  opacity: 0;
  transition: opacity 0.3s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
}

/* Options hover menu displays when the file is hovered or focused. */
.File-module__innerWrapper--OAaH9:hover .File-module__optionsContainer--Z3EVn,
.File-module__innerWrapper--OAaH9:focus .File-module__optionsContainer--Z3EVn,
.File-module__optionsContainer--Z3EVn:focus-within {
  opacity: 1;
}

.File-module__option--_nXj5 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  background-color: var(--transparent);
  gap: 0.25rem;
  color: var(--Primary-500, #3c82f6);
  font-family: "Font Awesome 6 Sharp";
  font-size: 15px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 0.15px;
}

.File-module__option--_nXj5:not(:disabled):hover {
  background: var(--Primary-200, #bfdbfe);
  border-color: var(--transparent);
}

.File-module__option--_nXj5:focus {
  border-color: var(--Primary-600, #2463eb);
}

.File-module__option--_nXj5:disabled {
  color: var(--Neutral-400, #a1a1aa);
}

.File-module__optionIcon--OAYRo {
  width: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/FileTree/File.module.css"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,sBAAA;EAEA,0BAAA;EACA,2CAAA;AAAD;;AAGA;EACC,0BAAA;EACA,kEAAA;EAEA,uBAAA;AADD;;AAIA;EACC,mBAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;EACA,2BAAA;AADD;;AAIA;EACC,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AADD;;AAIA;EACC,UAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EAEA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;AAFD;;AAKA,qEAAA;AACA;;;EAGC,UAAA;AAFD;;AAKA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EAEA,oCAAA;EACA,YAAA;EAEA,kCAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAJD;;AAOA;EACC,uCAAA;EACA,gCAAA;AAJD;;AAMA;EACC,yCAAA;AAHD;;AAKA;EACC,kCAAA;AAFD;;AAKA;EACC,WAAA;AAFD","sourcesContent":[".fileNameWrapper {\n\tcursor: pointer;\n\tborder-radius: 0.25rem;\n\n\twidth: calc(100% - 3.6rem);\n\t/* prevents from overflowing the filetree */\n}\n\n.fileNameWrapper:hover .innerWrapper {\n\twidth: calc(100% - 3.6rem);\n\t/* gives room for Reset/Delete buttons (File.tsx) after filename */\n\n\ttransition: width 0s 0s;\n}\n\n.innerWrapper {\n\talign-items: center;\n\tgap: 0.5rem;\n\tpadding: 0;\n\tletter-spacing: 0.01rem;\n\twidth: 100%;\n\ttransition: width 0.1s 0.1s;\n}\n\n.fileName {\n\tdisplay: block;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tflex-grow: 1;\n}\n\n.optionsContainer {\n\topacity: 0;\n\ttransition: opacity 0.3s;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.5rem;\n\tmargin-left: 0.5rem;\n\tmargin-right: 0.5rem;\n\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n}\n\n/* Options hover menu displays when the file is hovered or focused. */\n.innerWrapper:hover .optionsContainer,\n.innerWrapper:focus .optionsContainer,\n.optionsContainer:focus-within {\n\topacity: 1;\n}\n\n.option {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 1.5rem;\n\theight: 1.5rem;\n\n\tbackground-color: var(--transparent);\n\tgap: 0.25rem;\n\n\tcolor: var(--Primary-500, #3c82f6);\n\tfont-family: \"Font Awesome 6 Sharp\";\n\tfont-size: 15px;\n\tfont-style: normal;\n\tfont-weight: 900;\n\tline-height: normal;\n\tletter-spacing: 0.15px;\n}\n\n.option:not(:disabled):hover {\n\tbackground: var(--Primary-200, #bfdbfe);\n\tborder-color: var(--transparent);\n}\n.option:focus {\n\tborder-color: var(--Primary-600, #2463eb);\n}\n.option:disabled {\n\tcolor: var(--Neutral-400, #a1a1aa);\n}\n\n.optionIcon {\n\twidth: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fileNameWrapper": `File-module__fileNameWrapper--ZpBLN`,
	"innerWrapper": `File-module__innerWrapper--OAaH9`,
	"fileName": `File-module__fileName--pUMjq`,
	"optionsContainer": `File-module__optionsContainer--Z3EVn`,
	"option": `File-module__option--_nXj5`,
	"optionIcon": `File-module__optionIcon--OAYRo`
};
export default ___CSS_LOADER_EXPORT___;
